import { h } from "./../../utils/createElement";
import { __extends } from "tslib";
import * as React from 'react';
import Menu from '../Menu';
import { consumeTheme } from '../../utils/theme';
import { getOptionHtmlId, SelectOptionContext } from './context';
var Option = (function (_super) {
    __extends(Option, _super);
    function Option() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.themedRender = function (classNames) {
            var _a = _this.props, prefixCls = _a.prefixCls, className = _a.className, style = _a.style, children = _a.children, value = _a.value, disabled = _a.disabled;
            var _b = _this.context, parentMenuId = _b.parentMenuId, isMultiple = _b.isMultiple;
            var cls = classNames(prefixCls, className);
            return (h(Menu.Item, { className: cls, style: style, id: value, disabled: disabled, role: isMultiple ? 'checkbox' : 'option', htmlId: getOptionHtmlId(parentMenuId, value) }, children));
        };
        return _this;
    }
    Option.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    Option.contextType = SelectOptionContext;
    return Option;
}(React.Component));
export default Option;
Option.defaultProps = {
    prefixCls: 'dui-option',
    disabled: false,
};
